export { default as ManagerModel } from './ManagerModel';
export { default as ManagersListModel } from './ManagersListModel';
export { default as ManagersGateway } from './ManagersGateway';
export { default as ManagersService } from './ManagersService';
export { default as ManagersServiceProvider } from './ManagersServiceProvider';



// WEBPACK FOOTER //
// ./src/api/managers/index.js